import {ReduceStore} from 'flux/utils';
import Immutable from 'immutable';
import Dispatcher from '../Dispatcher';
import OverlayActionTypes from './OverlayActionTypes';

function cancelExistingLoadingOverlayTimeout(state) {
    let timeout = state.get('loadingOverlayTimeout');
    if (timeout) {
        clearTimeout(timeout);
    }
}

class OverlayStore extends ReduceStore {
    constructor() {
        super(Dispatcher);
    }

    getInitialState() {
        // eslint-disable-next-line new-cap
        return Immutable.OrderedMap({
            loadingOverlayTimeout: null,
            showLoadingOverlay: false,
            showLoadingOverlayDelay: 0,
            notifications: [],
            onboardingGuideIndex: 0,
            showOnboardingGuide: false,
            viewport: null,
            r360: null,
        });
    }

    reduce(state, action) {
        let newState = null;
        let notifications;
        switch (action.type) {
            case OverlayActionTypes.SET_R360_CONTEXT:
                newState = state.merge({
                    viewport: action.viewport,
                    r360: action.r360,
                });
                break;
            case OverlayActionTypes.SHOW_ONBOARDING_GUIDE:
                newState = state.merge({
                    showOnboardingGuide: action.showOnboardingGuide,
                });
                break;
            case OverlayActionTypes.VIEW_ONBOARDING_PAGE:
                newState = state.merge({
                    onboardingGuideIndex: action.pageIndex,
                });
                break;
            case OverlayActionTypes.SHOW_LOADING_OVERLAY:
                cancelExistingLoadingOverlayTimeout(state);
                newState = state.merge({
                    showLoadingOverlay: action.showLoadingOverlay,
                });
                break;
            case OverlayActionTypes.SCHEDULE_LOADING_OVERLAY:
                cancelExistingLoadingOverlayTimeout(state);
                newState = state.merge({
                    loadingOverlayTimeout: action.loadingOverlayTimeout,
                });
                break;
            case OverlayActionTypes.ADD_NOTIFICATION:
                notifications = (state.get('notifications') || []).slice();
                notifications.push({
                    titleKey: action.titleTranslationKey,
                    msgKey: action.messageTranslationKey,
                    id: action.id,
                    type: action.notificationType,
                    actions: action.actions,
                });
                newState = state.merge({
                    notifications,
                });
                break;
            case OverlayActionTypes.REMOVE_NOTIFICATIONS:
                notifications = state.get('notifications').slice();
                action.ids.forEach((id) => {
                    let expiredNotificationIndex = notifications.indexOf((notification) => {
                        return notification.id === id;
                    });
                    if (expiredNotificationIndex >= 0) {
                        notifications = notifications.splice(expiredNotificationIndex, 1);
                    }
                });
                newState = state.merge({
                    notifications,
                });
                break;
            case OverlayActionTypes.CLEAR_NOTIFICATIONS:
                newState = state.merge({
                    notifications: [],
                });
                break;
            default:
                break;
        }
        return newState || state;
    }
}

export default new OverlayStore();
